import {BillingActionType} from "../../actions";

const DefaultBillingState = {
    termsList:[],
    feeList:[],
    filteredFeeList:[],
    warehouseList:[],
    calculateEstimate:{},
    calculateDetail:{}
}
export const billingReducer = ( state = DefaultBillingState, action = {}) =>
{
    switch (action.type) {
        case BillingActionType.Fetch_Terms:
            return { ...state, termsList: action.payload}
        case BillingActionType.Fetch_Fee_No:
            return { ...state, feeList: action.payload}
        case BillingActionType.Fetch_Filtered_Fee_No:
            return { ...state, filteredFeeList: action.payload}


        case BillingActionType.Fetch_Warehouse_Tax_Rate:

            return { ...state, warehouseList: action.payload}

        case BillingActionType.Calculate_Estimate:
            return { ...state, calculateEstimate: action.payload}

        case BillingActionType.Calculate_Detail:
            return { ...state, calculateDetail: action.payload}

        default:
            return state;
    }

}